// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_borderRight__ozEvJ{
    border-right: 1px solid rgba(0, 0, 0, 0.50);
    margin-left:auto;
    width: 80%;
}
.styles_marginRight__19tc8{
    /* padding-right: 5px; */
    margin-right: 5px;
}
.styles_borderLeft__kvgNF{
    border-left: 1px solid rgba(0, 0, 0, 0.50);
    width: 80%;
}
.styles_marginLeft__7ASKF{
    /* padding-right: 5px; */
    margin-left: 10px;
}
.styles_displayFlex__Xs6HQ{
    display:flex !important;
    color: #000 !important;
}
.styles_name__bQWO4{
    padding:0 10px;
}
.styles_imageStyle__PbDmp{
    border:1px solid rgba(0,0,0,0.5);
    width: 40px;
    height: 40px !important;
    border-radius:  5px;
    object-fit: cover;
}
.styles_displayFlex__Xs6HQ{
    word-break: break-all;
    height: 39px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/OnlineChat/ReplyBox/styles.module.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI,0CAA0C;IAC1C,UAAU;AACd;AACA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;AACA;IACI,gCAAgC;IAChC,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,YAAY;AAChB","sourcesContent":[".borderRight{\n    border-right: 1px solid rgba(0, 0, 0, 0.50);\n    margin-left:auto;\n    width: 80%;\n}\n.marginRight{\n    /* padding-right: 5px; */\n    margin-right: 5px;\n}\n.borderLeft{\n    border-left: 1px solid rgba(0, 0, 0, 0.50);\n    width: 80%;\n}\n.marginLeft{\n    /* padding-right: 5px; */\n    margin-left: 10px;\n}\n.displayFlex{\n    display:flex !important;\n    color: #000 !important;\n}\n.name{\n    padding:0 10px;\n}\n.imageStyle{\n    border:1px solid rgba(0,0,0,0.5);\n    width: 40px;\n    height: 40px !important;\n    border-radius:  5px;\n    object-fit: cover;\n}\n.displayFlex{\n    word-break: break-all;\n    height: 39px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"borderRight": `styles_borderRight__ozEvJ`,
	"marginRight": `styles_marginRight__19tc8`,
	"borderLeft": `styles_borderLeft__kvgNF`,
	"marginLeft": `styles_marginLeft__7ASKF`,
	"displayFlex": `styles_displayFlex__Xs6HQ`,
	"name": `styles_name__bQWO4`,
	"imageStyle": `styles_imageStyle__PbDmp`
};
export default ___CSS_LOADER_EXPORT___;
